import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/audit-logs",
    children: [
      {
        name: "audit-logs",
        path: "",
        component: () => import("../presentation/pages/AuditLogs.vue"),
        meta: {
          layout: "default",
          public: false,
          action: "list",
          subject: "audit_log",
        },
      },
      {
        name: "all-audit-logs",
        path: "all",
        component: () => import("../presentation/pages/AllAuditLogs.vue"),
        meta: {
          layout: "default",
          public: false,
          action: "list_all",
          subject: "audit_log",
        },
      },
    ],
  },
];
